import React from 'react';
import PropTypes from 'prop-types';

import FilterNumberPair from "components/search_sidebar/filter_number_pair";

export default class HospitalityFilters extends React.Component {

  static propTypes = {
    filterKeyMappings: PropTypes.object.isRequired,
    filterLabelMappings: PropTypes.object.isRequired,
    propertyFilter: PropTypes.shape({
      lotUnits: PropTypes.string,
      apnNumber: PropTypes.string,
      maxBuildingSize: PropTypes.string,
      maxCeilingHeight: PropTypes.string,
      maxLotSize: PropTypes.string,
      maxNumUnits: PropTypes.string,
      maxYearBuilt: PropTypes.string,
      minBuildingSize: PropTypes.string,
      minCeilingHeight: PropTypes.string,
      minLotSize: PropTypes.string,
      minNumUnits: PropTypes.string,
      minYearBuilt: PropTypes.string
    }).isRequired,
    onPropertyFilterChange: PropTypes.func.isRequired
  };

  handleChange = (e, name) => {
    this.props.onPropertyFilterChange(e, name);
  }

  render() {
    const {
      filterKeyMappings,
      filterLabelMappings,
      propertyFilter,
    } = this.props;

    return (
      <React.Fragment>
        <div className="row left-buffer-sm right-buffer-sm">
          <div className="pl-0 col-md-12 pr-0">
            <FilterNumberPair
              filter={propertyFilter}
              label={filterLabelMappings['numKeys']}
              valueKeys={filterKeyMappings['numKeys']}
              onChange={this.handleChange}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}